export default {
  created() {
    if (process.client) {
      this.clientCreated()
    } else {
      this.serverCreated()
    }
  },
  methods: {
    clientCreated() {},
    serverCreated() {}
  }
}
